import React from "react";

import { getPlanLabel, isFreePlan } from "@app/analytics/account/Billing/utils";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import ROUTES from "@app/common/routes";
import { BillingPlan } from "@app/common/types";
import Config from "@app/config";

import AlertBanner from "@rui/AlertBanner";
import { Link } from "@rui/Link";

const RecordingCappedBanner = ({ planType }: { planType?: BillingPlan }) => {
  const { currentPlan } = useBillingContext();

  if (!planType) return null;

  const recordingMinutes = Config.billing.meetingRecordingMinutes[planType];
  const planThatLimitedRecordingDuration = getPlanLabel(planType);

  return (
    <AlertBanner severity="info">
      This meeting exceeds the recording duration of {recordingMinutes} minutes
      per meeting on the {planThatLimitedRecordingDuration} plan. Only the first{" "}
      {recordingMinutes} minutes were recorded by Read.
      {isFreePlan(currentPlan.type) && isFreePlan(planType) && (
        <>
          {" "}
          <Link to={ROUTES.UPGRADE_ACCOUNT}>Upgrade your account</Link> to
          measure meetings longer than {recordingMinutes} minutes.
        </>
      )}
    </AlertBanner>
  );
};

export default RecordingCappedBanner;
